export enum ArticleType {
  Educational = 'educational-article',
  Listing = 'listing-article',
  Presell = 'presell-article',
}
